import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const SeparatorWrapper = styled.div`
  display: flex;
  margin: 0 ${Spacing.S16};
`
